import { render, staticRenderFns } from "./SecuritySituationRecordInfo.vue?vue&type=template&id=5808dd99&"
import script from "./SecuritySituationRecordInfo.vue?vue&type=script&lang=js&"
export * from "./SecuritySituationRecordInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports